import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SweetAlert from 'sweetalert-react';
import { clearErrors } from '../actions';

class InvalidPromoError extends Component {
  closeModal = () => {
    this.props.clearErrors();
  };

  confirm = () => {
    this.closeModal();
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  };

  render() {
    return (
      <SweetAlert
        show={this.props.hasError}
        title="Heads Up!"
        text={this.props.errorMessage}
        type="warning"
        confirmButtonColor="#009d92"
        confirmButtonText="Yes"
        showCancelButton
        cancelButtonText="No"
        onEscapeKey={this.closeModal}
        onConfirm={this.confirm}
        onCancel={this.closeModal}
      />
    );
  }
}

InvalidPromoError.propTypes = {
  errorMessage: PropTypes.string,
  clearErrors: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  onConfirm: PropTypes.func, // eslint-disable-line react/require-default-props
};

InvalidPromoError.defaultProps = {
  errorMessage: '',
  hasError: false,
};

const mapStateToProps = state => ({
  errorMessage: state.reservation.get('errorMessage'),
  hasError: !!state.reservation.get('errorMessage'),
});

const mapDispatchToProps = dispatch => ({
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvalidPromoError);



// WEBPACK FOOTER //
// ./src/app/components/InvalidPromoError.jsx